module.exports = __webpack_public_path__ + "img/acypi-01.9996b49c.jpg";